import { applyMiddleware, compose, createStore } from "redux";
import AppReducer from "../Reducers";
import { persistStore, persistReducer } from "redux-persist";
import { createFilter } from "redux-persist-transform-filter";
import { routerMiddleware } from "connected-react-router";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["router", "Puzzle", "Video", "Player", "Checkout"],
  transforms: [createFilter("Points", ["userID", "rules", "points"])],
};

export const history = createBrowserHistory();

export default (preloadedState) => {
  const persistedReducer = persistReducer(persistConfig, AppReducer(history));
  const composeEnhancer =
    process.env.NODE_ENV !== "production" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  const store = createStore(
    persistedReducer,
    preloadedState,
    composeEnhancer(applyMiddleware(thunk, routerMiddleware(history)))
  );

  return {
    store,
    persistor: persistStore(store),
  };
};
